/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_RootsInputs */

const cs_documents_roots = /** @type {(inputs: Documents_RootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostupné složky`)
};

const en_documents_roots = /** @type {(inputs: Documents_RootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders you can access`)
};

/**
* | output |
* | --- |
* | "Folders you can access" |
*
* @param {Documents_RootsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_roots = /** @type {((inputs?: Documents_RootsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_RootsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_roots(inputs)
	return cs_documents_roots(inputs)
});